// src/App.js
import React, { useEffect, useState } from "react";
import "./App.css";
import { verifyTelegram, setAuthToken } from "./api";
import Lobby from "./pages/Lobby";
import GameRoom from "./pages/GameRoom";

export default function App() {
  const tg = window.Telegram?.WebApp;
  const initData = tg?.initData || "";
  const initDataUnsafe = tg?.initDataUnsafe;

  const debug = window.location.search.includes("debug=true");

  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);
  const [telegramId, setTelegramId] = useState(null);
  const [view, setView] = useState("lobby"); // lobby | room
  const [room, setRoom] = useState(null);

  // -------------------------------
  // 1. AUTH
  // -------------------------------
  useEffect(() => {
    async function auth() {
      try {
        let realInitData = initData;

        // Debug режим: браузер без Telegram
        if (debug) {
          realInitData = "query_id=TEST&user=%7B%22id%22%3A1111%2C%22first_name%22%3A%22DebugUser%22%7D";
          console.log("DEBUG MODE: Using fake initData");
        }

        const resp = await verifyTelegram(realInitData);

        if (!resp.ok) throw new Error("AUTH_FAILED");

        setAuthToken(resp.token);
        setToken(resp.token);
        setTelegramId(resp.user.telegramId);

      } catch (err) {
        console.error("Auth error:", err);
      } finally {
        setLoading(false);
      }
    }

    auth();
  }, []);

  const handleEnterRoom = (roomObj) => {
    setRoom(roomObj);
    setView("room");
  };

  const handleExitRoom = () => {
    setRoom(null);
    setView("lobby");
  };

  if (loading) {
    return <div className="screen">Загрузка...</div>;
  }

  if (!token) {
    return <div className="screen">Ошибка авторизации</div>;
  }

  return (
    <div className="app">
      {view === "lobby" && (
        <Lobby
          token={token}
          telegramId={telegramId}
          onEnterRoom={handleEnterRoom}
        />
      )}

      {view === "room" && room && (
        <GameRoom
          token={token}
          telegramId={telegramId}
          room={room}
          onExit={handleExitRoom}
        />
      )}
    </div>
  );
}
